import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import DailyNourishmentDelivered from "./sections/DailyNourishmentDelivered";
import FreshFromTheOven from "./sections/FreshFromTheOven";
import OurCoreTechnicalDisciplines from "./sections/OurCoreTechnicalDisciplines";
import ThePerfectProtocol from "./sections/ThePerfectProtocol";
import TheScienceOfShine from "./sections/TheScienceOfShine";
import StartAProject from "./sections/StartAProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <DailyNourishmentDelivered />
      <FreshFromTheOven />
      <OurCoreTechnicalDisciplines />
      <ThePerfectProtocol />
      <TheScienceOfShine />
      <StartAProject />
      <Footer />
    </div>;
}